<template>
    <div v-show="showHoverCard"
         class="hover-card-wrapper"
         :class="hovePositionClass"
         :style="{height:innerCardHeight + 'px'}"
         @mouseup="handleMouseup"
         @mouseout="handleMouseout"
    >
      <div style="cursor: pointer;height: 100%;width: 100%;">
        <div v-if="showHead" class="hover-card-head"
             style="width:100%;border-bottom: 2px solid #dce2e6;cursor:move"
             @mousedown="handleMousedown"
             @mousemove="handleMousemove"
        >
          <slot name="head">
            <div class="hover-card-head-left"><Icon type="ios-information" :size="25" style="padding-bottom: 5px" /></div>
            <div class="hover-card-head-center">{{title}}</div>
            <div class="hover-card-head-right"><Icon type="ios-close" :size="25" style="padding-bottom: 5px" @click="onHideHoverCard" /></div>
          </slot>
        </div>
        <div class="hover-card-content"
        >
          <slot name="content">
            填充你的内容
          </slot>
          <Spin v-if="loading" fix>
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>{{loadingText}}</div>
          </Spin>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'hover-card',
  props: {
    cardHeight: {
      type: Number,
      default: 200
    },
    xPosition: {
      type: String,
      default: 'left'
    },
    showHead: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: '加载中...'
    }
  },
  data () {
    return {
      showHoverCard: false,
      isCanMove: false,
      offset: {},
      innerCardHeight: 200,
      contentHeight: 168
    }
  },
  methods: {
    onHideHoverCard () {
      this.showHoverCard = false
    },
    handleMouseout (e) {
      this.isCanMove = false
    },
    handleMouseup (e) {
      this.isCanMove = false
    },
    handleMousedown (e) {
      this.isCanMove = true
      this.offset = {
        x: e.pageX,
        y: e.pageY
      }
      e.preventDefault()
    },
    handleMousemove (e) {
      if (this.isCanMove) {
        this.innerCardHeight = this.offset.y - e.pageY + this.innerCardHeight
        this.offset.y = e.pageY
      }
    }
  },
  computed: {
    hovePositionClass () {
      return [
        { 'hover-card-left-bottom': this.xPosition === 'left' },
        { 'hover-card-right-bottom': this.xPosition === 'right' }
      ]
    }
  },
  watch: {
    value (val) {
      this.showHoverCard = val
    },
    showHoverCard (val) {
      this.$emit('input', val)
    }
  },
  mounted () {
    this.showHoverCard = this.value
    this.innerCardHeight = this.cardHeight
  }
}
</script>

<style scoped>
  .hover-card-left-bottom {
    left: 0;
    margin-left: 1px;
  }
  .hover-card-right-bottom {
    right: 0;
  }
  .hover-card-wrapper {
    border-radius: 4px;
    text-align: center;
    position: absolute;
    bottom: 0;
    background-color: whitesmoke;
    z-index: 100;
    height: 200px;
    width: 98%;
    border: 1px solid #d2cacad9;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19);
  }
  .hover-card-wrapper .hover-card-head {
    height: 30px;
    background-color: #dce2e6;
    width: 100%;
    padding: 2px 2px;
    line-height: 26px;
    /*text-align: left;*/
  }
  .hover-card-wrapper .hover-card-content {
    padding: 1px 2px 5px;
    overflow: scroll;
    width: 100%;
    height: calc(100% - 30px);
    position: relative;
  }
  .hover-card-head-right {
    width:30px; float:right;
    display: inline-block;
    cursor: pointer;
  }
  .hover-card-head-left {
    width:30px;
    display: inline-block;
    float: left;
  }
  .hover-card-head-center {
    display: inline-block;
  }
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
</style>
